<p-panel>
  <app-reactive-form-builder
    #formbuilder
    (formChanges)="formChanges($event[0], $event[1])"
    (goBack)="goBack()"
    (afterSend)="undefined"
    [form]="form.formFields"
    [serverUrl]="''"
    [dropdownLoadTrigger]="dropdownLoadTrigger"
    [id]="getModel().id ?? ''"
    [request]="getType() === formTypes.EDITION ? ventasApi.compradoresPUT : ventasApi.compradoresPOST"
    [getRequest]="ventasApi.compradoresGET">
  </app-reactive-form-builder>
</p-panel>